module.exports = __webpack_public_path__ + "assets/img/ranks.aa1014c5.png";